import { defineMessages } from "react-intl";
const messages = defineMessages({
    updateSpaceSettingsSuccess: {
        id: "app.space.details.settings.update.success.text",
        defaultMessage: "Space settings updated successfully.",
    },
    updateSpaceTitle: {
        id: "app.space.details.settings.title.text",
        defaultMessage: "Space Settings",
    },
    update: {
        id: "app.space.details.settings.update.button.text",
        defaultMessage: "Save",
    },
    updateFormSpaceAddress: {
        id: "app.space.details.settings.update.form.spaceAddress.text",
        defaultMessage: "Space Address",
    },
    updateFormSpaceAddressRequired: {
        id: "app.space.details.settings.update.form.spaceAddress.required.text",
        defaultMessage: "Address is required",
    },
    updateFormSpaceAddressInvalid: {
        id: "app.space.details.settings.update.form.spaceAddress.invalid.text",
        defaultMessage: "Address is invalid",
    },
    newSpaceAddress: {
        id: "app.space.details.settings.newSpaceAddress.text",
        defaultMessage: "Add New Address",
    },
    addNewAddressButtonText: {
        id: "app.space.details.settings.newAddress.button.text",
        defaultMessage: "Add Address",
    },
    newSpaceAddressPlaceholder: {
        id: "app.space.details.settings.newSpaceAddress.placehoder.text",
        defaultMessage: "Enter Address",
    },
    updateFormUnitNumber: {
        id: "app.space.details.settings.update.form.unitNumber.text",
        defaultMessage: "Unit Number",
    },
    updateFormUnitNumberRequired: {
        id: "app.space.details.settings.update.form.unitNumber.required.text",
        defaultMessage: "Unit Number is required",
    },
    updateFormIsModelUnit: {
        id: "app.space.details.settings.update.form.isModelUnit.text",
        defaultMessage: "Model Unit",
    },
    updateFormLabel: {
        id: "app.space.details.settings.update.form.description.text",
        defaultMessage: "Description",
    },
    updateFormDescription: {
        id: "app.space.details.settings.update.form.label.text",
        defaultMessage: "Description for this community",
    },
    updateFormNumberOfBedrooms: {
        id: "app.space.details.settings.update.form.numberOfBedrooms.text",
        defaultMessage: "Bedroom",
    },
    updateFormNumberOfBedroomsInvalid: {
        id: "app.space.details.settings.update.form.numberOfBedrooms.invalid.text",
        defaultMessage: "Number of bedrooms is invalid",
    },
    updateFormNumberOfBathrooms: {
        id: "app.space.details.settings.update.form.numberOfBathrooms.text",
        defaultMessage: "Bathroom",
    },
    updateFormNumberOfBathroomsInvalid: {
        id: "app.space.details.settings.update.form.numberOfBathrooms.invalid.text",
        defaultMessage: "Number of bathrooms is invalid",
    },
    updateFormAmenities: {
        id: "app.space.details.settings.update.form.amenities.text",
        defaultMessage: "Space Amenities",
    },
    updateFormLayoutType: {
        id: "app.space.details.settings.update.form.layoutType.text",
        defaultMessage: "FloorPlan Name",
    },
    updateForm: {
        id: "app.space.details.settings.update.form.amenities.text",
        defaultMessage: "Space Amenities",
    },
    updateFormRent: {
        id: "app.space.details.settings.update.form.rent.text",
        defaultMessage: "Rent",
    },
    updateFormRentInvalid: {
        id: "app.space.details.settings.update.form.rent.invalid.text",
        defaultMessage: "Rent can not exceed 99,999",
    },
    updateFormRentFormat: {
        id: "app.space.details.settings.update.form.rent.format.text",
        defaultMessage: "Rent invalid",
    },
    updateFormUnitSize: {
        id: "app.space.details.settings.update.form.unitSize.text",
        defaultMessage: "Unit Size",
    },
    updateFormUnitSizeInvalid: {
        id: "app.space.details.settings.update.form.unitSize.invalid.text",
        defaultMessage: "Unit size is invalid",
    },
    amenitiesAirConditioning: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.air.conditioning",
        defaultMessage: "Air Conditioning",
    },
    amenitiesBalcony: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.balcony",
        defaultMessage: "Balcony",
    },
    amenitiesDishwasher: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.dishwasher",
        defaultMessage: "Dishwasher",
    },
    amenitiesFurnished: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.furnished",
        defaultMessage: "Furnished",
    },
    amenitiesParking: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.parking",
        defaultMessage: "Parking",
    },
    amenitiesOutdoor: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.outdoor",
        defaultMessage: "Outdoor Space",
    },
    amenitiesStorage: {
        id: "app.space.details.settings.update.form.amenities.selector.defaults.options.storage",
        defaultMessage: "Storage Space",
    },
});
export default messages;
